export default __webpack_public_path__ + "static/media/mcfp.7748ed95.png";